// extracted by mini-css-extract-plugin
export default {"brownButton":"Buttons_brownButton__QN3tM","blue":"Buttons_blue__Vw26N","active":"Buttons_active__V+Xd9"};